class FeatureInstance
{
    constructor($uibModalInstance, feature)
    {
        this.feature = feature;
        this.modal = $uibModalInstance;
    }
    ok()
    {
        this.modal.close();
    }
}
FeatureInstance.$inject=['$uibModalInstance','feature'];
export {FeatureInstance}